import React from 'react'
import { default as PhoneInputComponent } from 'react-phone-input-2'

import { Box, Typography } from '@mui/material'
import { maskBrazilianPhone } from 'templates/Customers/Table/utils'

import { isBrazilianPhone, toBrazilianNationalDigits } from 'utils/FormatPhone'

import 'react-phone-input-2/lib/high-res.css'

interface PhoneDisplayProps {
  value: string
  size?: 'small' | 'medium'
}

// Format Brazilian phone removing country code if present
const formatBrazilianPhone = (phone: string): string =>
  maskBrazilianPhone(toBrazilianNationalDigits(phone))

export const PhoneDisplay: React.FC<PhoneDisplayProps> = ({
  value,
  size = 'medium'
}) => {
  if (!value) return null

  const isSmall = size === 'small'
  const isBrazilian = isBrazilianPhone(value)

  // For Brazilian phones, show formatted number without flag
  if (isBrazilian) {
    return (
      <Typography
        component="span"
        sx={{
          fontSize: '14px',
          fontFamily: "'Inter', Roboto, sans-serif",
          color: 'inherit'
        }}
      >
        {formatBrazilianPhone(value)}
      </Typography>
    )
  }

  // For international phones, use react-phone-input-2 in disabled mode
  const digits = value.replace(/\D/g, '')

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        '& .react-tel-input': {
          width: 'auto',
          fontFamily: "'Inter', Roboto, sans-serif"
        },
        '& .react-tel-input .form-control': {
          border: 'none',
          background: 'transparent',
          padding: '0',
          paddingLeft: isSmall ? '32px' : '38px',
          height: 'auto',
          fontSize: '14px',
          color: 'inherit',
          width: 'auto',
          cursor: 'default'
        },
        '& .react-tel-input .flag-dropdown': {
          border: 'none',
          background: 'transparent',
          position: 'absolute',
          left: 0
        },
        '& .react-tel-input .selected-flag': {
          padding: 0,
          width: isSmall ? '28px' : '34px',
          background: 'transparent !important'
        },
        '& .react-tel-input .selected-flag .flag': {
          transform: isSmall ? 'scale(0.85)' : 'scale(1)'
        },
        '& .react-tel-input .selected-flag .arrow': {
          display: 'none'
        }
      }}
    >
      <PhoneInputComponent
        value={digits}
        disabled
        disableDropdown
        enableTerritories
        inputStyle={{
          cursor: 'default'
        }}
      />
    </Box>
  )
}

export default PhoneDisplay
